import React, { useState } from 'react'
import * as Yup from 'yup';
import { GetConfiguracao, UpdateConfiguracao } from '@app/api/naoPrevistos/parametros'
import { CompositeView, FormSubmitButton, FormatText, GridView, MasterDetailForm, SimpleView, Widget, usePromise } from '@digital/ui'
import { Collapse, Icon } from 'antd';
import { hasPermission } from '@app/helpers/permissions';
import { CurrencyInput3 } from '@app/components/CurrencyInput3';

const { Panel } = Collapse;

const CadastroParametrosAprovacao = () => {
    const [onupdate, setOnupdate] = useState(false);
    const [dados] = usePromise(async () => await GetConfiguracao(), [], {});

    const update = values => {
        UpdateConfiguracao(values).then(data => {
            if (data.valid) {
                setOnupdate(!onupdate);
            }
        });
    };

    return (
        <SimpleView>
            <CompositeView>
                <GridView noform>
                    <Collapse defaultActiveKey={'configuracoes'} bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
                        <Panel key="configuracoes" header="Parâmetros de alçadas de aprovações">
                            <MasterDetailForm
                                initialValues={dados}
                                onSubmit={update}
                                validationSchema={Yup.object().shape({
                                    faixaInicialAprovacao: Yup.number()
                                        .transform(value => (isNaN(value) ? undefined : value))
                                        .required('O campo deve ser informado')
                                        .test('faixaInicialAprovacao', 'O campo deve ser menor que o valor da faixa final', function (value) {
                                            return value < this.parent.faixaFinalAprovacao // não pode ser maior que o valor da faixa final
                                        }),
                                    faixaFinalAprovacao: Yup.number()
                                        .transform(value => (isNaN(value) ? undefined : value))
                                        .required('O campo deve ser informado')
                                        .test('faixaFinalAprovacao', 'O campo deve ser maior que o valor da faixa inicial', function (value) {
                                            return value > this.parent.faixaInicialAprovacao // não pode ser menor que o valor da faixa inicial
                                        }),

                                })}>
                                <Widget
                                    actions={[
                                        hasPermission(['NAO_PREVISTO_PARAMETROS_VISUALIZAR_MENU']) && (
                                            <FormSubmitButton noIcon={true} type="primary">
                                                <FormatText id="ui.commons.save" uppercase />
                                            </FormSubmitButton>
                                        ),
                                    ]}>
                                    <CurrencyInput3 label="Faixa Inicial Aprovação" name="faixaInicialAprovacao" span={3} />
                                    <CurrencyInput3 label="Faixa Final Aprovação" name="faixaFinalAprovacao" span={3} />
                                </Widget>
                            </MasterDetailForm>
                        </Panel>
                    </Collapse>
                </GridView>
            </CompositeView>
        </SimpleView>
    )
}

export default CadastroParametrosAprovacao